export default {
  errorsRootKey: 'sites',
  resource: 'sites',
  actions: ['index']
}
